import gql from 'graphql-tag';

export const DWELLING_MUTATION = gql`
  mutation saveDwelling($dwellingInput: DwellingInput!) {
    saveDwelling(dwelling: $dwellingInput) {
      id
      address_Street
      address_Street_Line2
      address_City
      address_State
      address_Zip
      yearBuilt
      ownerAssociation
      numberOfUnits
      squareFootage
      _Ebb_PolicyId
      _Ebb_ProgramCycleId
    }
  }
`;
export const WITHDRAW_DWELLING_MUTATION = gql`
         mutation withdrawDwelling($dwellingInput: DwellingInput!, $dwellingId: String) {
           withdrawDwelling(dwelling: $dwellingInput, dwellingId: $dwellingId) {
             id
             address_Street
             address_Street_Line2
             address_City
             address_State
             address_Zip
             yearBuilt
             _Ebb_PolicyId
             _Ebb_ProgramCycleId
           }
         }
       `;
export const EDIT_DWELLING_MUTATION = gql`
  mutation saveDwelling($dwellingInput: DwellingInput!, $dwellingId: String) {
    saveDwelling(dwelling: $dwellingInput, dwellingId: $dwellingId) {
      id
      address_Street
      address_Street_Line2
      address_City
      address_State
      address_Zip
      yearBuilt
      ownerAssociation
      numberOfUnits
      squareFootage
      _Ebb_PolicyId
      _Ebb_ProgramCycleId
      sys_EnrollmentError
    }
  }
`;
